import React, { useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  list-style: none;
  padding-bottom: 8px;
  display: flex;
  column-gap: 12px;
  border-bottom: 1px solid #F1F1F1;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

const CategoryListItem = styled.div`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #919191;
  padding-bottom: ${({ theme }) => theme.spacing.xs};

  &.active {
    border-bottom: 2px solid #58c3bb;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: #071C3E;
  }
`;

const Categories = ({data, onClickHandler}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <Wrapper>
      {data.map((category, index) => (
        <CategoryListItem
          key={index}
          className={activeIndex === index ? 'active' : ''}
          onClick={() => {
            setActiveIndex(index);
            onClickHandler(category.id);
          }}
        >
          {category.value}
        </CategoryListItem>
      ))}
      </Wrapper>
  );
};

export default Categories;
